var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassSmallLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 20
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1006"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 492",
    d: "M32 14.999a4.76 4.76 0 00-1.857-3.831 4.293 4.293 0 01-2.292 1.951 4.17 4.17 0 002.334-3.718 4.237 4.237 0 00-4.3-4.182 2.839 2.839 0 00-.435.022 9.236 9.236 0 01.815 3.541H26.2a10.313 10.313 0 00-20.4 0h-.068a8.846 8.846 0 01.752-3.5A7.3 7.3 0 000 12.594a7.51 7.51 0 007.611 7.405h19.355v-.007A5.065 5.065 0 0032 14.999z",
    fill: "#746de4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Subtraction 1047",
    d: "M16 18a8 8 0 01-3.114-15.371 8.002 8.002 0 016.228 14.743A7.95 7.95 0 0116 18zm0-15.03A7.03 7.03 0 1023.03 10 7.038 7.038 0 0016 2.97z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 654",
    d: "M12.497 13.229V6.95a1.25 1.25 0 011.25-1.25h3.574a3.212 3.212 0 013.176 3.17 3.212 3.212 0 01-3.176 3.169h-2.324v1.19a1.25 1.25 0 11-2.5 0zm4.774-3.384a.976.976 0 100-1.951h-2.274v1.951z",
    fill: "#fff"
  }))));
}
export default SvgPassSmallLogo;